export class TaxRate {

  public id: string;
  public class: string;
  public country: string;
  public state: string;
  public postcode: string;
  public city: string;
  public rate: string;
  public name: string;
  public priority: string;
  public compound: boolean;
  public shipping: boolean;

}
